// assets
import styled from 'styled-components';
import { HTMLAttributes } from 'react';

import SVGLogo from './assets/wf.svg';

export const LogoContainer = styled.div<
    {
        $height?: number;
        $isAuthenticated?: boolean;
    } & HTMLAttributes<HTMLDivElement>
>`
    display: flex;
    align-items: center;
    gap: 8px;
    height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
    cursor: ${({ $isAuthenticated }) => ($isAuthenticated ? 'pointer' : 'default')};
`;

export const LogoImage = styled(SVGLogo)`
    display: block;
    height: 25px;
    width: auto;
`;
